import * as actionTypes from '../actions/actionTypes';

const initialState = {
    package_list: [],
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.PACKAGES_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                package_list: []
            };
        case actionTypes.PACKAGES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                package_list: []
            };
        case actionTypes.PACKAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                package_list: action.payload
            };
        default:
            return state;
    }
};

export default reducer;